<template>
  <div ref="uploader">
    <label :for="label">
      <slot></slot>
    </label>
    <input
      :id="label"
      class="file-photo cursor-pointer"
      type="file"
      @change="handleImage"
      @dragenter="hovering = true"
      @dragleave="hovering = false"
    />
  </div>
</template>

<style>
.file-photo {
  display: none;
}
.enabled .file-photo {
  cursor: pointer;
  display: none;
}
.uploader img {
  position: absolute;
}
</style>

<script>
import axios from "axios";
export default {
  props: ["label"],
  data() {
    return {
      hovering: false,
      preview: null
    };
  },
  computed: {
    backgroundImage() {
      let image = this.preview || this.value;
      if (!image) {
        return null;
      }
      return `url('${image}')`;
    }
  },
  methods: {
    uploadImage(file) {
      const formData = new FormData();
      formData.append("file", file);
      //formData.append("id", 75);
      // console.log(file)
      // let uploaded = {
      //   "id": String(Math.floor(Date.now())),
      //   "name": file.name,
      //   "link": "unknown"
      // }
      // this.$emit("uploaded", uploaded)
      // console.log(uploaded)
      const chatAPI = "service7.upskill.com.bd";
      axios
        .post(`https://${chatAPI}/upload`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "X-Auth-Secret": localStorage.getItem("ctoken")
          }
        })
        .then(res => {
          let uploadedData = {
            id: String(Math.floor(Date.now() / 1000)),
            name: file.name,
            link: res.data.link
          };
          this.$emit("uploaded", uploadedData);
        });
    },
    handleImage(event) {
      let files = event.target.files;
      if (files.length === 0) {
        return;
      }
      let reader = new FileReader();
      reader.onload = event => {
        this.preview = event.target.result;
        this.$emit("input", files[0]);
        this.uploadImage(files[0]);
      };
      reader.readAsDataURL(files[0]);
    }
  }
};
</script>
